export const USERDATAEMPLOYEE_DELETE_RESET = 'USERDATAEMPLOYEE_DELETE_RESET'
export const USERDATAEMPLOYEE_DELETE_SET_ERROR = 'USERDATAEMPLOYEE_DELETE_SET_ERROR'
export const USERDATAEMPLOYEE_DELETE_SET_DELETED = 'USERDATAEMPLOYEE_DELETE_SET_DELETED'
export const USERDATAEMPLOYEE_DELETE_TOGGLE_LOADING = 'USERDATAEMPLOYEE_DELETE_TOGGLE_LOADING'
